<header class="w-100 overflow-hidden">
    <nav class="navbar navbar-expand-lg navbar-light bg-successs fixed-top shadow align-items-center">
        <a class="navbar-brand" href="/home"><img src="assets/images/Veggelands-new-logo.png" style="height:2rem;"></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav justify-content-sm-center mx-auto">
                <li class="nav-item text-center li-hover">
                    <a class="nav-linkss active" (click)="goHome()">Home <span class="sr-only">(current)</span></a>
                </li>
                <li class="nav-item text-center li-hover">
                    <a class="nav-linkss" (click)="goProducts()">Products</a>
                </li>
                <li class="nav-item text-center li-hover">
                    <a class="nav-linkss" (click)="historyDetail()">Order History</a>
                </li>
                <li class="nav-item text-center li-hover">
                    <a class="nav-linkss" (click)="openDetails()">Contact Us</a>
                </li>
            </ul>
            <ul (click)="goProducts()" class="d-flex justify-content-center m-0 mr-3" style="cursor: pointer;">
                <li class="text-center d-flex flex-column li-hover">
                    <div class="d-flex justify-content-end">
                        <span class="badge badge-pill badge-success border badge-cart">{{cartData}}</span></div>
                    <span class="fa fa-cart-plus fa fa-3x"></span>
                </li>
            </ul>
            <div class="Profile-area d-flex justify-content-center align-items-center p-0 m-0">
                <div class="dropdown">
                    <figure class="p-0 m-0" *ngIf="logedIn == false">
                        <img id="profile-pic" src="/assets/images/user.png" alt="user profile pic">
                        <a (click)="login()" class="text-dark"><span>LogIn</span> </a>
                    </figure>
                    <figure class="p-0 m-0" *ngIf="logedIn == true">
                        <img id="profile-pic" src="{{photo}}" onError="this.src='assets/images/user.png'" alt="user profile pic">
                        <div class="dropdown-content border-radius" *ngIf="logedIn == true">
                            <p (click)="changeLocation()"
                                class="d-flex justify-content-center pointer-hover hover-zoom"><img class="image-size"
                                    src="assets/images/pin.png" alt="Select Location px-3"><span class="text-black-50">
                                    {{cityName}}</span></p>

                            <p class="w-100 bold">{{name}}</p>
                            <hr>
                            <a (click)="goAccount()" class="text-success w-100"><span>My Account</span> </a>
                            <br>
                            <a (click)="logout()" class="text-success w-100"><span>Logout</span> </a>
                        </div>
                    </figure>
                </div>
            </div>
        </div>
    </nav>
</header>
<!-- Modal -->
<button class="d-none" data-toggle="modal" data-target="#exampleModalHeader" id="btnClickHeader"></button>
<div class="modal fade" data-backdrop="static" id="exampleModalHeader" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog model-width" role="document">
        <div class="modal-content pb-4">
            <div class="d-none mt-2 mr-3">
                <button type="button" id="dismisButtonHeader" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true" class="fa fa-close"></span>
                </button>
            </div>
            <div class="modal-body">
                <app-cities (sendDetails)="getDetail($event)"></app-cities>
            </div>
            <!-- button -->
        </div>
    </div>
</div>